import React from "react";
import { connect } from "react-redux";
import { Transition, Header, Segment, Button } from "semantic-ui-react";
import { preinscripcionesOps } from "../../ducks/preinscripciones";
import isEmpty from "lodash/isEmpty";
import Tabla from "./listaPreinscripciones/Tabla";

class ListaPreinscripciones extends React.Component {
  state = {
    confirmacionCompleta: false,
    inscripcionConfirmada: null
  };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;
    this.props.obtenerDatosColegio(params.idColegio);
    this.props.obtenerPreinscripcionesDelColegio(params.idColegio);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      confirmacionCompleta: nextProps.dataSaved.status
    };
  }

  componentWillUnmount() {
    this.props.limpiarPreinscripcionesDelColegio();
    this.props.limpiarDatosColegio();
    this.props.detachPreinscripcionesDelColegio();
  }

  handleConfirm = ({ idInscripcion, formaDePago }) =>
    this.props.confirmarInscripcion({
      idColegio: this.props.match.params.idColegio,
      idInscripcion,
      formaDePago
    });

  handleMatinal = idInscripcion => {
    const {
      match: { params }
    } = this.props;
    this.props.setTipoEscuela({
      idColegio: params.idColegio,
      idInscripcion,
      tipo: "matinal"
    });
  };

  handleVespertina = idInscripcion => {
    const { idColegio } = this.props.match.params;
    this.props.setTipoEscuela({
      idColegio,
      idInscripcion,
      tipo: "vespertina"
    });
  };

  handleBorrarLinea = ({ idInscripcion }) => {
    const {
      match: {
        params: { idColegio }
      }
    } = this.props;

    this.props.borrarInscripcion({ idColegio, idInscripcion });
  };

  handleVolver = () => this.props.history.goBack();

  render() {
    const { datosColegio } = this.props;
    return (
      <Transition.Group animation="scale" duration={250}>
        {!isEmpty(datosColegio) && (
          <React.Fragment>
            <Segment basic>
              <Button
                content="Volver"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <Header
                inverted
                as="h2"
                content={`Preinscripciones ${datosColegio.nombre}`}
              />
            </Segment>
            <Tabla
              datos={this.props.datos}
              idColegio={datosColegio.idColegio}
              columnaSeleccionada={this.props.columnaSeleccionada}
              onColumnSelect={this.props.columnaAlumnosSeleccionada}
              handleRowConfirm={this.handleConfirm}
              handleMatinal={this.handleMatinal}
              handleVespertina={this.handleVespertina}
              handleBorrarLinea={this.handleBorrarLinea}
              inscripcionConfirmada={this.state.inscripcionConfirmada}
              confirmacionCompleta={this.state.confirmacionCompleta}
            />
          </React.Fragment>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  datosColegio: state.preinscripciones.datosColegio,
  datos: state.preinscripciones.preinscripcionesDelColegio,
  columnaSeleccionada: state.preinscripciones.columnaSeleccionada,
  dataSaved: state.preinscripciones.dataSaved
});

const mapDispatchToProps = {
  obtenerPreinscripcionesDelColegio:
    preinscripcionesOps.obtenerPreinscripcionesDelColegio,
  detachPreinscripcionesDelColegio:
    preinscripcionesOps.detachPreinscripcionesDelColegio,
  limpiarPreinscripcionesDelColegio:
    preinscripcionesOps.limpiarPreinscripcionesDelColegio,
  obtenerDatosColegio: preinscripcionesOps.obtenerDatosColegio,
  limpiarDatosColegio: preinscripcionesOps.limpiarDatosColegio,
  columnaAlumnosSeleccionada: preinscripcionesOps.columnaAlumnosSeleccionada,
  confirmarInscripcion: preinscripcionesOps.confirmarInscripcion,
  setTipoEscuela: preinscripcionesOps.setTipoEscuela,
  borrarInscripcion: preinscripcionesOps.borrarInscripcion,
  resetSavedData: preinscripcionesOps.resetSavedData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaPreinscripciones);



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/ListaPreinscripciones.jsx